import React, { createContext, useEffect, useState } from "react";
import i18next from "i18next";
import "./i18n";
export const LanguageContext = createContext();

const applyDocumentDir = (lang) => {
  try {
    const safe = lang === "ar" ? "ar" : "en";
    document.documentElement.setAttribute("lang", safe);
    document.documentElement.setAttribute("dir", safe === "ar" ? "rtl" : "ltr");
  } catch (_) {}
};

export const LanguageProvider = ({ children }) => {
  let [language, setLanguage] = useState(i18next.language);

  // Set <html dir> on mount and whenever the active language changes.
  useEffect(() => {
    applyDocumentDir(i18next.language);
    const handler = (lng) => {
      applyDocumentDir(lng);
      setLanguage(lng);
    };
    i18next.on("languageChanged", handler);
    return () => i18next.off("languageChanged", handler);
  }, []);

  let changeLanguage = (lang) => {
    i18next.changeLanguage(lang);
  };
  return (
    <LanguageContext.Provider
      value={{
        language,
        changeLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
